import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

const supportContactsKey = (customerId?: string) => ['supportContacts', customerId];

interface ISupportContacts {
  data: Data;
}

interface Data {
  salespersons: TeamMember[];
  customerSuccessManagers: TeamMember[];
  leadAnalysts: TeamMember[];
}

interface TeamMember {
  id: number;
  fullName: string;
  role: string;
  profileImageUrl: null | string;
}

const supportContactsFn = ({ queryKey }: QueryFunctionContext<(string | number)[]>) =>
  apiClient.get(`${APP_SSO_URL}api/customers/${queryKey[1]}/support-contacts`);

const supportConstactsSelect = ({ data }: { data: ISupportContacts }): TeamMember[] => [
  ...data.data.salespersons,
  ...data.data.customerSuccessManagers,
  ...data.data.leadAnalysts,
];

export const useSupportContactsQuery = (customerId?: string) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: supportContactsKey(customerId),
    queryFn: supportContactsFn,
    select: supportConstactsSelect,
  });
};
